<section
  class="plans-promo"
  [class.plans-promo--pdp]="layout === 'pdp'"
  [class.plans-promo--selectable]="selectable"
  [attr.aria-labelledby]="layout === 'home' ? 'plans-promo-heading' : null"
  [attr.aria-label]="layout === 'pdp' ? 'Planes Mega móvil disponibles' : null">
  <div [class.container]="layout === 'home'">
    <div *ngIf="layout === 'home'" class="title4 watch-heading-unified plans-promo__heading">
      <h2 class="title-inner4" id="plans-promo-heading">DESCUBRE EL PLAN QUE SE ADAPTA A TI</h2>
      <div class="line"><span></span></div>
    </div>

    <p *ngIf="errorMessage" class="plans-promo__footnote-line text-center mb-4" role="status">
      {{ errorMessage }}
    </p>

    <div
      class="row plans-promo__grid"
      [ngClass]="layout === 'pdp' ? 'g-3 g-lg-4 plans-promo__grid--pdp' : 'g-4 g-lg-5'"
      *ngIf="!loading && plans.length">
      <div
        *ngFor="let plan of plans; let i = index; trackBy: trackByPlanId"
        class="plans-promo__col"
        [ngClass]="layout === 'pdp' ? 'plans-promo__col--pdp' : 'col-12 col-md-6 col-lg-4'"
        [class.plans-promo__col--tablet-center]="layout === 'home' && i === 2">
        <article
          class="plans-promo__card"
          [class.plans-promo__card--selected]="isPlanSelected(plan)"
          [attr.role]="selectable ? 'button' : null"
          [attr.tabindex]="selectable ? 0 : null"
          [attr.aria-pressed]="selectable ? isPlanSelected(plan) : null"
          (click)="onPlanCardClick(plan)"
          (keydown)="onPlanCardKeydown($event, plan)">
          <header class="plans-promo__header">
            <h3 class="plans-promo__title">{{ plan.title }}</h3>
            <p class="plans-promo__subtitle">{{ plan.subtitle }}</p>
          </header>

          <div class="plans-promo__social-block">
            <p class="plans-promo__social-lead">
              <span class="plans-promo__plus" aria-hidden="true">+</span>
              REDES SOCIALES <strong>ILIMITADAS</strong>*
            </p>
            <ul *ngIf="layout === 'home'" class="plans-promo__social-list" role="list">
              <li *ngFor="let network of plan.socialNetworks; trackBy: trackBySocial">
                <span
                  class="plans-promo__social-icon"
                  [ngClass]="'plans-promo__social-icon--' + network"
                  [attr.aria-label]="network">
                  <i *ngIf="socialIconClass(network) as iconClass" [class]="iconClass" aria-hidden="true"></i>
                  <span
                    *ngIf="usesCustomSocialIcon(network)"
                    class="plans-promo__social-custom"
                    [ngClass]="'plans-promo__social-custom--' + network"
                    aria-hidden="true"></span>
                </span>
              </li>
            </ul>
            <p class="plans-promo__number-note">CONSERVANDO TU MISMO NÚMERO</p>
          </div>

          <div class="plans-promo__pricing">
            <span class="plans-promo__price-label">POR SOLO</span>
            <p class="plans-promo__price">
              <span class="plans-promo__price-amount">{{ plan.priceLabel }}*</span>
              <span class="plans-promo__price-period">al mes</span>
            </p>
          </div>

          <a
            *ngIf="layout === 'home'"
            href="javascript:void(0)"
            class="plans-promo__cta"
            (click)="onContractClick($event)">
            {{ plan.ctaLabel }}
          </a>

          <p
            *ngIf="layout === 'pdp' && selectable && isPlanSelected(plan)"
            class="plans-promo__selected-label"
            aria-live="polite">
            Plan seleccionado
          </p>
        </article>
      </div>
    </div>

    <footer *ngIf="layout === 'home'" class="plans-promo__footnote">
      <p class="plans-promo__footnote-line">Todos los planes cuentan con</p>
      <p class="plans-promo__footnote-line">Minutos y SMS</p>
      <p class="plans-promo__footnote-highlight">ILIMITADOS</p>
    </footer>
  </div>
</section>
